import React from 'react';
import { SecDocument } from "../../types";

interface ViewPdfProps {
  file: SecDocument;
}

export const ViewPdf: React.FC<ViewPdfProps> = ({ file }) => {
  return (
    <iframe
      src={`${file.url}#view=FitH`}
      className="w-full h-full"
      title="PDF Viewer"
      style={{ height: '100%', width: '100%', border: 'none' }} 
    />
  );
};